// Bootstrap for layout-level JavaScript globals emitted by the
// `js_globals_tag` Rails helper. Reads `<meta name="js-globals">` and
// spreads each top-level key onto `window.<key>`. Replaces the inline
// `:javascript` blocks that used to bootstrap things like
// `apple_logo_url`, `signin_users_path`, etc. in `application.haml` and
// `application_shared.haml`.
//
// Re-runs on every `turbo:load` because Turbo replaces the `<meta>`
// element along with the rest of the page.

function loadJsGlobals() {
  const meta = document.querySelector('meta[name="js-globals"]');
  if (!meta) return;
  try {
    const data = JSON.parse(meta.content);
    Object.keys(data).forEach((key) => {
      window[key] = data[key];
    });
  } catch (e) {
    console.error("[lib/js_globals] invalid js-globals JSON", e);
  }
}

document.addEventListener("turbo:load", loadJsGlobals);
loadJsGlobals();
